module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1188.e2233598.png";